import { makeStyles } from '@material-ui/core/styles'
import { Theme, Box } from '@material-ui/core'
import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { FinalSelection } from '../utils'

const useStyles = makeStyles((theme: Theme) => ({
  productStyle: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightBold,
  },
  alignRight: {
    textAlign: 'right',
    textWrap: 'nowrap',
  },
}))

interface QuoteItemProps {
  isDealer: boolean
  isAuUser: string | boolean
  row: FinalSelection
}
const QuoteItem: React.FC<QuoteItemProps> = ({ isDealer, isAuUser, row }) => {
  const classes = useStyles()

  const calculateTotalPrice = () => {
    if (!isDealer && isAuUser) {
      return <FormattedMessage id="QUOTE_ITEM" defaultMessage="Quote Item" />
    } else if (row?.price && row?.currency) {
      return (
        <FormattedNumber
          style="currency"
          currencyDisplay="symbol"
          currency={row?.currency}
          value={parseFloat(row?.price) * row?.quantity}
        />
      )
    } else {
      return '__'
    }
  }

  return (
    <Box className={`${classes.productStyle} ${classes.alignRight}`}>
      {calculateTotalPrice()}
    </Box>
  )
}

export default QuoteItem
